import { Divider, Grid, InputAdornment } from '@material-ui/core';
import { Button, Icons, TextField, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { useMst } from '../../mobx-models/Root';
import { FieldInspectorTab } from '../../utilities/enums';
import useStyles from './InspectionListFilter.styles';

interface Props {
  tabValue: number;
  openWorkPackageFiles: () => void;
  handleSearch: (event: React.FocusEvent<HTMLInputElement>) => void;
  filterOneStyle: boolean;
  filterTwoStyle: boolean;
  handleFilterOne: () => void;
  handleFilterTwo: () => void;
  endAndornmentSearch: () => void;
  searchText: string;
  checkInspectionList: boolean;
}

const InspectionListFilter: React.FC<Props> = ({
  searchText,
  endAndornmentSearch,
  openWorkPackageFiles,
  handleSearch,
  tabValue,
  filterOneStyle,
  filterTwoStyle,
  handleFilterTwo,
  handleFilterOne,
  checkInspectionList,
}: Props) => {
  const { HandleGesture } = useMst();
  const classes = useStyles();

  const checkTabValue = () => {
    if (!HandleGesture.bulkUpload) {
      return tabValue !== FieldInspectorTab.UNASSIGN;
    }
    return HandleGesture.gestureForReAssign && tabValue !== FieldInspectorTab.APPROVAL;
  };

  return (
    <>
      {checkTabValue() && !HandleGesture.gestureForSignAndStamp && (
        <>
          <Grid hidden={checkInspectionList} item className={classes.quickFilterGrid}>
            <Typography variant="body1" className={classes.quickFilterText}>
              Quick Filter
            </Typography>
          </Grid>
          <Grid
            hidden={checkInspectionList}
            item
            className={`${classes.statusGrid} ${classes.filterbutton}`}
          >
            <Button
              data-testid="ins-list-inProgress"
              id="inProgress"
              color="secondary"
              variant={filterOneStyle ? 'contained' : undefined}
              noMinHeight
              onClick={handleFilterOne}
              data-cy="in progress"
              className={`${filterOneStyle ? 'buttonWhenContained' : 'buttonWhenNotContained'}`}
            >
              <Typography variant="body1">
                {tabValue === FieldInspectorTab.ONGOING ? 'In Progress' : 'Pending Approval'}
              </Typography>
            </Button>
          </Grid>

          <Grid
            hidden={checkInspectionList}
            item
            className={`${classes.stampingGrid} ${classes.filterbutton}`}
          >
            <Button
              data-testid="ins-list-assigned"
              id="assigned"
              color="secondary"
              variant={filterTwoStyle ? 'contained' : undefined}
              noMinHeight
              onClick={handleFilterTwo}
              data-cy="assigned"
              className={`${filterTwoStyle ? 'buttonWhenContained' : 'buttonWhenNotContained'}`}
            >
              <Typography variant="body1">
                {tabValue === FieldInspectorTab.ONGOING ? 'Assigned' : 'Stamping'}
              </Typography>
            </Button>
          </Grid>
          <Grid hidden={checkInspectionList} item className={classes.diverderGrid}>
            <Divider orientation="vertical" className={classes.divider} />
          </Grid>
        </>
      )}

      <Grid hidden={checkInspectionList} item className={classes.searchField}>
        <Grid className="searchTextbox">
          <TextField
            inputProps={{ 'data-testid': 'inspection-search-input' }}
            data-testid="inspection-search"
            hidden={checkInspectionList}
            noMinHeight
            variant="outlined"
            size="small"
            type="text"
            focused
            startAdornment={
              <InputAdornment position="start">
                <Icons.SearchFeather hidden={checkInspectionList} color="primary" />
              </InputAdornment>
            }
            endAdornment={endAndornmentSearch()}
            placeholder="Search"
            value={searchText}
            onChange={handleSearch}
          />
        </Grid>
      </Grid>
      <Grid hidden={checkInspectionList} item className={classes.searchBarDividerGrid}>
        <Divider orientation="vertical" className={classes.divider} />
      </Grid>
      <Grid
        data-testid="openWorkpageDialog"
        item
        onClick={openWorkPackageFiles}
        className={classes.downloadIcon}
      >
        <Icons.DownloadFeather color="primary" />
      </Grid>
    </>
  );
};

export default observer(InspectionListFilter);
